<div
  class="w-full surface-0"
  data-testid="client-appointment-booking-list-v2"
>
  <app-data-grid    [columnData]="tableData$"
    [columns]="tableColumns$"
    [totalRecords]="totalRecordLength"
    [selectable]="false"
    [paginator]="true"
    [loading]="loading"
    [EmptyState]="emptyStateComponent$"
    tableClasses="p-0 w-full"
    [headerClasses]="'surface-100 text-xs text-600 white-space-nowrap'"
    [EmptyStateClass]="'pt-1 pb-2 text-center surface-0'"
    [gridName]="'appointment-bookings-v2-list'"
    aria-label="appointment-bookings-v2-table"
    data-testid="appointment-bookings-v2-table"
    (loadNextData)="fetchNextSetData($event)"
    (rowClickEvent)="onRowClick($event)"
  />

  <client-booking-detail-dialog
    [visible]="detailVisible"
    [loading]="detailLoading"
    bookingKind="appointment"
    [detail]="selectedDetail"
    (closed)="closeDetail()"
  />
</div>
